import { AuthService } from "@js/services/AuthService";
import { CommercialDealService } from "@js/services/Deal/CommercialDealService";
import { SharedSearchResultsService } from "@js/services/Deal/SharedSearchResultsService";
import { OrganisationService } from "@js/services/OrganisationService";
import { RoleService } from "@js/services/RoleService";
import { SelectListService } from "@js/services/SelectListService";
import { SharedDataService } from "@js/services/SharedDataService";
import { CompareResultsService } from "@js/services/CompareResultsService";
import {
  CaseAccessLevelEnum,
  CaseLenderStateEnum,
  CaseStatusEnum,
  CommercialDealClient,
  DealClient,
  DealClientClient,
  DealLenderClient,
  EPCRatingTypeEnum,
  EWS1GradeTypeEnum,
  EventLogEnum,
  FixedRateTermEnum,
  InterestRateTypeEnum,
  LenderClient,
  OrganisationClient,
  OrganisationLinkClient,
  OwnOrPurchaseEnum,
  ProductClient,
  ProductFamilyEnum,
  PropertyTypeEnum,
  SortByEnum,
  TimeLeftOnLeaseEnum,
  UserClient,
  BrickflowEventLogClient,
  CommercialSearchResultsClient,
  CommercialDeal,
  DealLender,
  CommercialLenderResultSummaryDTO,
  LenderProductPairDTO,
  ApplicationUser,
  UserSimpleDTO,
  Organisation,
  ShareDealDTO,
  MakeReferralMessageRequest,
  CommercialSearchResultsResponse,
  Client,
  SaveAsSearchRequest,
  SaveCommercialSearchRequest,
  StaticDataClient,
  ApplicationUserCrudClient,
  ProductSourceTypeEnum,
  ShortlistRequest,
  SortOrderEnum,
  DealCrudClient,
  CommercialDealCrudClient,
  IncorrectDataTypeEnum,
  FlagIncorrectRateOrCriteriaRequest,
} from "@src/apis/ModularClient";
import DealHelper from "@js/helpers/DealHelper";
import { BridgingPersonalGuaranteeLevelEnum } from "@js/models/enum/BridgingPersonalGuaranteeLevelEnum";
import { MaxIndividualUnitPriceEnum } from "@js/models/enum/MaxIndividualUnitPriceEnum";
import { UserService } from "@js/services/UserService";
import { BaseLenderResultsScreenController } from "./BaseLenderResultsScreenController";
import { IndexService } from "@js/services/IndexService";
import { DealLenderService } from "@js/services/Deal/DealLenderService";
import { ODataHelper } from "@js/helpers/ODataHelper";
import { TrustAsHtmlHelper } from "@js/helpers/TrustAsHtmlHelper";

declare const window: Window & { dataLayer: any[] };

export class CommercialLenderResultScreenController extends BaseLenderResultsScreenController<CommercialDeal> {
  // tourState: any = {
  //   tourStep: 1,
  //   tourTotalSteps: 0,
  // };
  guidanceCheckbox: boolean = true;
  // tourEnabled: boolean = false;
  totalLender: number = 0;
  isSearch: boolean = true;
  debug1: boolean = false;
  dealLenders: DealLender[];
  tempLoanCriteria = null;
  comparisonList: CommercialLenderResultSummaryDTO[] = [];
  snapshotNewSearch: boolean = false;
  showLenderNamesAndLogosOverride: boolean = false;
  dealUniqueRef: string = null;
  dealClientUniqueRef: string = null;
  orgName: string = "Brickflow";
  mortgageTerm: number = 0;

  //session storage values for enterprise journey
  userRole: string = null;
  clientId: number = null;

  //Enterprise user
  user: ApplicationUser;
  showEnterpriseRegistrationModal: boolean = false;
  projectName: string = "";
  hasAccessToDeal: boolean = true;
  summarySearchResults: CommercialLenderResultSummaryDTO[];
  initialSummarySearchResults: CommercialLenderResultSummaryDTO[];
  productLastVerifiedDates = {};
  sliderShown: boolean;
  isAssigned: boolean = false;
  inActiveDealLender: number = 0;
  moveContactBrokerBtnInMiddle: boolean = false;
  brokerDetail: string = "";
  brokerageOrgFilename: string;

  isLoggingOut: boolean = false;
  appName: string;

  toggleEditSearchName: boolean = false;
  showProductNote: boolean = false;
  productNote: string;
  offer: CommercialLenderResultSummaryDTO;
  loanLabel: string;
  ShowdeleteSearch: boolean = false;
  warningOff: boolean = false;
  emailExistsError: boolean = false;
  showMessageToborrower: boolean = false;
  borrowerMessage: string = "";
  showContactBrokerModal: boolean = false;

  borrowingEntityTypeOptions = [];
  interestRateTypeOptions = [];
  loanRepaymentTypeOptions = [];
  timeLeftOnLeaseOptions = [];
  numberOfPreviousDevelopmentsOptions = [];
  personalGuaranteeLevelOptions = [];
  maxIndividualUnitPriceOptions = [];
  acceptableEPCRatingOptions = [];
  acceptableEWS1GradeTypeOptions = [];
  currentUseofBuildingOptions = [];
  tradingPeriodOptions = [];
  fixedrateTermOptions = [];
  locationOptions = [];
  yearsTradingOptions = [];
  maxIndividualUnitPrice = null;
  acceptableEPCRating = null;
  maxCommercialFloorspaceOptions = [];

  hasSearchChanged: boolean = false;
  showFilters: boolean = false;
  personalGuaranteeLevel = null;

  isProceedClicked: boolean = false;
  isSaveorSaveAsClicked: boolean = false;
  productResultList: number;
  isSaveAsWthOutIntroducee: boolean = false;
  // Flag to disable or enable the Save as button depending on the click.
  isClicked: boolean = false;
  //This boolean is used in the shareedmodal.html for all the deals
  isDeal: boolean = true;
  showSortBy: boolean = false;

  isResultScreen: boolean = true;

  showPostcodeErrorMessage: boolean = false;
  postcodeErrorMsg: string;
  isPostcodeChange: boolean = false;
  noAccessToDealMsg: string;
  //LenderReferralSearch
  isLenderReferredSearch: boolean = false;

  hasResultsProcessed: boolean = false;

  //SaveAs functionality
  reloadSearch: boolean = false;

  //Enterprise journey
  password: string = null;
  error: string = "";

  isCommercial: boolean = true;

  // Previously shortlisted/submitted lenders which are not visible on current results because of criteria change
  HiddenDealLenderList: DealLender[] = [];

  showExportOptions: boolean = false;

  //Confirm phone number for new client, when they register through enterprise journey from results page
  showClientPhoneNumberConfirmationModal: boolean = false;
  clientUpdatedContact: string;
  confirmClientPhoneNumberForm: ng.IFormController;
  clientUpdatedContactErrorMessage: string;
  // Logging in/resetting password
  isLoginError: boolean = false;
  isResetPasswordSubmitted: boolean = false;
  registrationLoginError: string = null;

  //inaccurate rate/criteria
  flaggedOffer: CommercialLenderResultSummaryDTO;
  filterProperties = [
    "f_IsFirstTimeDeveloper",
    "f_IsPersonalName",
    "f_IsOffshoreCompany",
    "f_IsMainShareholderOverseas",
    "f_PersonalGuaranteeMax",
    "f_MinOwnershipPeriod",
    "f_HasAdverseCredit",
    "f_MaxCommercialFloorspace",
    "f_IsGradeOneListed",
    "f_IsGradeTwoListed",
    "f_IsTimberFrameConstruction",
    "f_IsConcreteConstruction",
    "f_MaxIndividualUnitPrice",
    "f_AcceptableEPCRating",
    "f_IsFixedRate",
    "f_IsRetypedValuation",
    "f_IsChargeOnAdditionalProperty",
    "f_IsInterestOnly",
    "f_IsCapitalAndRepayment",
    "f_EWS1AcceptableType",
    "f_MaxAgeAtStartOfMortgageTerm",
    "f_MaxAgeAtEndOfMortgageTerm",
  ];

  static $inject = [
    "$route",
    "$routeParams",
    "$scope",
    "$rootScope",
    "$location",
    "$cookies",
    "OrganisationService",
    "OrganisationClient",
    "CommercialSearchResultsClient",
    "SelectListService",
    "BrickflowEventLogClient",
    "LenderClient",
    "DealLenderClient",
    "RoleService",
    "UserService",
    "UserClient",
    "ApplicationUserCrudClient",
    "IndexService",
    "SharedSearchResultsService",
    "CommercialDealService",
    "CommercialDealClient",
    "DealClient",
    "AuthService",
    "DealClientClient",
    "ProductClient",
    "OrganisationLinkClient",
    "SharedDataService",
    "StaticDataClient",
    "DealLenderService",
    "CompareResultsService",
    "ODataHelper",
    "TrustAsHtmlHelper",
    "$filter",
    "$timeout",
    "CommercialDealCrudClient",
  ];

  constructor(
    private $route: ng.route.IRouteService,
    private $routeParams: ng.route.IRouteParamsService,
    private $scope: ng.IScope,
    $rootScope: ng.IRootScopeService,
    $location: ng.ILocationService,
    private $cookies: ng.cookies.ICookiesService,
    private organisationService: OrganisationService,
    organisationClient: OrganisationClient,
    private commercialSearchResultsClient: CommercialSearchResultsClient,
    private selectListService: SelectListService,
    eventLogClient: BrickflowEventLogClient,
    lenderClient: LenderClient,
    private dealLenderClient: DealLenderClient,
    roleService: RoleService,
    private $user: UserService,
    userClient: UserClient,
    applicationUserCrudClient: ApplicationUserCrudClient,
    indexService: IndexService,
    private sharedSearchResultsService: SharedSearchResultsService,
    private commercialDealService: CommercialDealService,
    private commercialDealClient: CommercialDealClient,
    dealClient: DealClient,
    private $auth: AuthService,
    private dealClientClient: DealClientClient,
    private productClient: ProductClient,
    organisationLinkClient: OrganisationLinkClient,
    sharedDataService: SharedDataService,
    private staticDataClient: StaticDataClient,
    private dealLenderService: DealLenderService,
    private compareResultsService: CompareResultsService,
    odataHelper: ODataHelper,
    trustAsHtmlHelper: TrustAsHtmlHelper,
    private $filter: ng.IFilterService,
    private $timeout: ng.ITimeoutService,
    private commercialDealCrudClient: CommercialDealCrudClient,
  ) {
    super(
      $rootScope,
      $location,
      applicationUserCrudClient,
      indexService,
      roleService,
      lenderClient,
      userClient,
      sharedDataService,
      organisationClient,
      eventLogClient,
      organisationLinkClient,
      dealClient,
      odataHelper,
      trustAsHtmlHelper,
    );

    if (this.$routeParams.dealId && $location.search().source === "email") {
      dealClient.getDealStatus(this.$routeParams.dealId).then((status) => {
        if (status !== undefined && status !== null && status != CaseStatusEnum.Search) {
          $location.path(`/commercialcasedashboard/${this.$routeParams.dealId}`);
          $location.search("source", null); // Remove the query param
        } else {
          $location.search("source", null); // Still remove it if you don't need it anymore
        }
      });
    } else {
      this.init();
    }
  }

  init() {
    if (this.$location.path().startsWith("/commercialshortlistmore")) {
      this.isShortlistingMore = true;
    }

    //Hide header for borrower on page header
    /* if (
       window.self == window.top &&
       sessionStorage.getItem("userRole") &&
       sessionStorage.getItem("userRole") == "borrower" &&
       !$cookies.get("access_token")
     ) {
       document.getElementById("header").style.display = "none";
     }*/

    if (this.$routeParams.dealId) {
      if (/^\d+$/.test(this.$routeParams.dealId)) {
        // Treat the reference as an ID (e.g., fetch data using the ID)
        this.searchid = Number(this.$routeParams.dealId);
      } else {
        // Treat the reference as a unique string (e.g., fetch data using the string)
        this.dealUniqueRef = this.$routeParams.dealId;
      }
    }

    if (this.$routeParams.dealclientuniqueref) {
      this.dealClientUniqueRef = this.$routeParams.dealclientuniqueref;
    }

    if (window.self == window.top && this.$cookies.get("access_token")) {
      //This block is to navigate a broker to userdashboard when they do not have a license.
      if (sessionStorage.getItem("isValidLicense") == "false") {
        this.$auth.clearSelectedNavMenuAndFilterStorageData();
        this.$location.path("/userdashboard");
      }

      this.isLoggedInUser = true;
      this.loadingData = true;
      this.organisationService
        .getOrganisation()
        .then((organisation) => {
          if (organisation) {
            this.orgCode = organisation.isWhiteLabelled ? organisation.organisationCode : "";
            this.showLenderNamesAndLogosOverride = organisation.showLenderNames ?? false;
            if (organisation.isWhiteLabelled) {
              this.orgName = organisation.name.replace(/ /g, "_");
            }
          }
        })
        .catch((error) => {
          this.loadingData = false;
        })
        .finally(() => {
          // this.loadingData = false;
        });
    } else {
      if (window.self == window.top) {
        //this.userRole = sessionStorage.getItem('userRole');
        this.isClient = this.userRole == "borrower";
        this.orgCode = this.$cookies.get("org_code");
        // this.clientId = sessionStorage.getItem('clientId');
        this.getSearchCriteriaAndResults();
      } else {
        this.orgCode = location.pathname.replace("/", "");
        this.guidanceCheckbox = false;
        Promise.all([
          this.organisationService.getData("userRole").then((userRole) => {
            if (userRole) {
              this.userRole = userRole;
              this.isClient = this.userRole == "borrower";
            }
          }) /*,
                        this.organisationService.getData('clientId').then(clientId => {
                            if (clientId) {
                                this.clientId = clientId;
                            }
                        })*/,
          //Try get session storage if running in iframe before getting results
          this.organisationService.getData("newSearch").then((newSearch) => {
            if (newSearch) {
              this.snapshotNewSearch = newSearch == "true";
            }
          }),
        ])
          .then(() => {
            this.orgCode = location.pathname.replace("/", "");
            this.organisationService.sendDataToParent("newSearch", "false");
            this.getSearchCriteriaAndResults();
          })
          .catch((error) => {
            // One or both of the promises were rejected, handle the error
            console.error("Failed to get user data: ", error);
          });
      }
    }

    if (window.self == window.top) {
      // let cookieTourStep = this.$cookies.get("tourStep");
      // if (cookieTourStep) {
      //   this.tourState.tourStep = cookieTourStep;
      // }

      //if user is logged in, get profile
      if (this.$cookies.get("access_token")) {
        this.initialiseProfileData();
      } else {
        this.isClient = true; // if the user isn't logged in then this is the enterprise journey and should be treated as a borrower/client
      }

      // this.updateGuidanceState();

      // $rootScope.$on("guidanceStateChanged", (event: ng.IAngularEvent) => {
      //   this.updateGuidanceState();
      // });

      let logoutUnregister = this.$rootScope.$on("logout", (event: ng.IAngularEvent) => {
        this.isLoggingOut = true;
      });

      this.$scope.$on("$destroy", logoutUnregister);

      // $rootScope.$on("nextTour", (event: ng.IAngularEvent) => {
      //   this.tourNext();
      // });
      // $rootScope.$on("backTour", (event: ng.IAngularEvent) => {
      //   this.tourBack();
      // });
      // $rootScope.$on("skipTour", (event: ng.IAngularEvent) => {
      //   this.tourSkip();
      // });
    }

    this.interestRateTypeOptions = this.selectListService.GetInterestRateType();
    this.loanRepaymentTypeOptions = this.selectListService.GetLoanRepaymentTypeOptions();
    this.timeLeftOnLeaseOptions = this.selectListService.GetTimeLeftOnLeaseOptions();
    this.personalGuaranteeLevelOptions = this.selectListService.GetBridgingPersonalGuaranteeLevels();
    this.maxIndividualUnitPriceOptions = this.selectListService.GetMaxIndividualUnitPrices();
    this.acceptableEPCRatingOptions = this.selectListService.GetAcceptableEPCRating();
    this.acceptableEWS1GradeTypeOptions = this.selectListService.GetEWS1GradeType();
    this.fixedrateTermOptions = this.selectListService.GetFixedRateTermOptions();
    this.locationOptions = this.selectListService.GetLocations();
    this.tradingPeriodOptions = this.selectListService.GetTradingPeriodTypes();
    this.maxCommercialFloorspaceOptions = this.selectListService.GetMaxCommercialFloorspaceOptions();
  }

  getRequiredRoles(isCaseDashboard: boolean) {
    if (isCaseDashboard) return `['Admin', 'Client', 'Broker', 'Introducer']`;
    return `['Admin', 'Client', 'Broker', 'Introducer', 'Lender']`;
  }

  /**
   * Gets the search results and criteria for selected search
   * @param none
   */
  getSearchCriteriaAndResults() {
    if (window.self == window.top) {
      this.snapshotNewSearch = sessionStorage.getItem("newSearch") == "true";
      sessionStorage.setItem("newSearch", "false");
    }

    if (this.searchid) {
      this.loadingData = true;
      this.commercialSearchResultsClient
        .getSearchCriteriaAndResults({
          dealId: this.searchid,
          criteriaChanged: this.snapshotNewSearch,
          limit: 0,
          debug1: false,
          debug2: false,
          dealClientUniqueRef: null,
          dealUniqueRef: null,
          returnSearchCriteriaDTO: true,
          maxShortlistsAllowed: this.noOfShortlistAllowed,
        })
        .then((results: CommercialSearchResultsResponse) => {
          if (!results || !results.criteria) {
            this.noAccessToDealMsg = "Unable to find deal.";
            this.hasAccessToDeal = false;
          }

          this.shortlistDisabled = !results.canShortListMore;
          if (this.shortlistDisabled) this.sliderShown = false;

          this.postResultsProcessing(results);
        })
        .then(() => {
          if (this.summarySearchResults != null) {
            const productIds = this.summarySearchResults.map((product) => product.productID);
            this.getProductLastVerifiedDates(productIds);
          }
        })
        .then(() => {
          this.getSearchLenderCount();
          if (this.isLoggedInUser) this.getSelectedProducts();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          if (this.loanCriteria) {
            this.tempLoanCriteria = { ...this.loanCriteria };
            this.isSearch = this.loanCriteria && this.loanCriteria.status == CaseStatusEnum.Search;
            this.tempLoanCriteria = { ...this.loanCriteria };
            this.currentUseofBuildingOptions = this.selectListService.GetPropertyTypes(this.loanCriteria.productType);
            this.borrowingEntityTypeOptions = this.selectListService.GetBorrowingEntityTypeOptions(
              this.loanCriteria.productType,
            );
            this.loadingData = false;
            this.hasResultsProcessed = true;
          }
        });
    } else if (this.dealUniqueRef) {
      this.loadingData = true;
      this.commercialSearchResultsClient
        .getSearchCriteriaAndResults({
          dealUniqueRef: this.dealUniqueRef,
          criteriaChanged: this.snapshotNewSearch,
          dealId: null,
          dealClientUniqueRef: null,
          returnSearchCriteriaDTO: true,
          limit: 0,
          debug1: false,
          debug2: false,
        })
        .then((results) => {
          this.postResultsProcessing(results);
        })
        .then(() => {
          if (this.summarySearchResults != null) {
            const productIds = this.summarySearchResults.map((product) => product.productID);
            this.getProductLastVerifiedDates(productIds);
          }
        })
        .then(() => {
          this.getSearchLenderCount();
          if (this.loanCriteria) this.getSelectedProducts();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          if (this.loanCriteria) {
            this.isSearch = this.loanCriteria && this.loanCriteria.status == CaseStatusEnum.Search;
            this.tempLoanCriteria = { ...this.loanCriteria };
            this.currentUseofBuildingOptions = this.selectListService.GetPropertyTypes(this.loanCriteria.productType);
            this.borrowingEntityTypeOptions = this.selectListService.GetBorrowingEntityTypeOptions(
              this.loanCriteria.productType,
            );
            this.loadingData = false;
            this.hasResultsProcessed = true;
          }
        });
    } else if (this.dealClientUniqueRef) {
      this.loadingData = true;
      this.commercialSearchResultsClient
        .getSearchCriteriaAndResults({
          dealClientUniqueRef: this.dealClientUniqueRef,
          criteriaChanged: this.snapshotNewSearch,
          dealId: null,
          dealUniqueRef: null,
          returnSearchCriteriaDTO: true,
          limit: 0,
          debug1: false,
          debug2: false,
        })
        .then((results) => {
          this.postResultsProcessing(results);
        })
        .then(() => {
          if (this.summarySearchResults != null) {
            const productIds = this.summarySearchResults.map((product) => product.productID);
            this.getProductLastVerifiedDates(productIds);
          }
        })
        .then(() => {
          if (this.loanCriteria) this.getSelectedProducts();
          this.getSearchLenderCount();
          if (this.compareResultsService.exists() && (this.$rootScope as any).previousRoute.startsWith("/compare")) {
            this.comparisonList = JSON.parse(sessionStorage.getItem("ComparisonList"));

            //Removing lsd data saved for compare view.
            this.compareResultsService.clear();
            sessionStorage.removeItem("ComparisonList");
          }
        })
        .catch((error) => {})
        .finally(() => {
          this.isSearch = this.loanCriteria && this.loanCriteria.status == CaseStatusEnum.Search;
          this.tempLoanCriteria = { ...this.loanCriteria };
          this.currentUseofBuildingOptions = this.selectListService.GetPropertyTypes(this.loanCriteria?.productType);
          this.borrowingEntityTypeOptions = this.selectListService.GetBorrowingEntityTypeOptions(
            this.loanCriteria.productType,
          );
          this.loadingData = false;
          this.hasResultsProcessed = true;
        });
    }
  }

  postResultsProcessing(results) {
    if (results.hideDeal || results.hasNoAccessToDeal) {
      if (results.hasNoAccessToDeal) {
        if (this.isClient) {
          this.noAccessToDealMsg = "Please contact your broker in order to access this case.";
        } else {
          this.noAccessToDealMsg = "Error retrieving deal.";
        }
      } else {
        this.noAccessToDealMsg =
          "You cannot access commercial search results. Please contact your admin for more details.";
      }
      this.hasAccessToDeal = false;
    } else {
      this.summarySearchResults = this.initialSummarySearchResults = results.results;
      this.loanCriteria = results.criteria;

      if (this.isLoggedInUser) {
        this.validateAccessAndRedirect();
      }

      this.sortSummaryResults();

      if (this.loanCriteria.loanTermReq && this.loanCriteria.loanTermReq > 0) {
        this.mortgageTerm = this.loanCriteria.loanTermReq / 12;
      }

      if (this.isLoggedInUser) {
        if (this.dealClientUniqueRef) {
          if (this.isClient) {
            this.eventLogClient.logPageLoad(
              "AFTER-ENTERPRISE-LEAD-REGISTRATION-USING-EMAIL-LINK",
              this.orgCode,
              this.selectedUserName,
              "Client",
              this.loanCriteria?.organisationLinkId,
              this.loanCriteria.productType,
              "",
              this.loanCriteria?.id,
            );
          }
        } else {
          if (this.loanCriteria.lenderReferralLenderId) this.isLenderReferredSearch = true;

          // Showing confirm client phone number modal once client register through result page
          if (this.isClient && sessionStorage.getItem("showConfirmClientPhoneNo") == "true") {
            this.showClientPhoneNumberConfirmationModal = true;
            this.clientUpdatedContact = this.loanCriteria?.dealClients[0].client.phoneNumber;
          }
          // Expanding a 'new search' panel for first time search execution
          if (window.self == window.top && sessionStorage.getItem("newSearch")) {
            this.sliderShown =
              (this.$rootScope as any).previousRoute.startsWith("/compare") ||
              this.showClientPhoneNumberConfirmationModal
                ? false
                : true;
            sessionStorage.removeItem("newSearch");
          }
        }
      } else {
        if (this.$location.path().startsWith("/e/commercialresults")) {
          this.populateEnterpriseClientValue("LENDERRESULTS");
        }

        if (this.dealClientUniqueRef) {
          if (this.$routeParams.showOnlyRegister == "false") this.isClient = true;
          this.populateEnterpriseClientValue("LENDERRESULTS-USING-EMAIL-LINK");
        }
      }

      var owner =
        this.loanCriteria.dealClients != null && this.loanCriteria.dealClients?.length > 0
          ? this.loanCriteria.dealClients.find((dc) => dc.isPrimary)
          : null;

      if (owner) {
        this.isAssigned = true;
      }
    }
  }

  checkDeletedLender(lenderId: number, productId: number, externalProductId: string): boolean {
    if (this.isShortlistingMore && this.deletedDealLenders) {
      const deletedLender = this.deletedDealLenders.find((deletedLender) => deletedLender.lenderId === lenderId);

      if (deletedLender) {
        if (deletedLender.productSourceType == ProductSourceTypeEnum.Internal) {
          return deletedLender.productId === productId;
        } else {
          return deletedLender.externalProductId === externalProductId;
        }
      }
    }
    return false;
  }

  getSearchLenderCount() {
    this.lenderClient
      .getTotalLenders(ProductFamilyEnum.Commercial, this.loanCriteria.brokerOrganisationId)
      .then((result: number) => {
        this.totalLender = result;
      });
  }

  getSelectedProducts() {
    if (this.summarySearchResults && this.summarySearchResults.length > 0) {
      this.dealLenderClient
        .fetchDealLendersByDealId(this.dealClientUniqueRef || this.dealUniqueRef ? this.loanCriteria.id : this.searchid)
        .then((results) => {
          this.dealLenders = results;
        })
        .then(() => {
          this.comparisonList = this.summarySearchResults.filter((result) => {
            const isDealLender = this.dealLenders.find((dealLender) => this.isMatchingDealLender(result, dealLender));
            if (isDealLender) {
              result.dealLenderStatus = isDealLender.status;
            }
            return (result.isDealLender = Boolean(isDealLender));
          });

          // Previously shortlisted/submitted lenders which are not visible on current results because of criteria change
          this.HiddenDealLenderList = this.dealLenders.filter(
            (l) => !this.summarySearchResults.some((s) => this.isMatchingDealLender(s, l)),
          );

          if (this.comparisonList.length > 0) {
            var inActiveDealLenderList = this.comparisonList.filter(
              (ia) =>
                ia.dealLenderStatus == CaseLenderStateEnum.Rejected ||
                ia.dealLenderStatus == CaseLenderStateEnum.Withdrawn,
            );
            this.inActiveDealLender = inActiveDealLenderList.length;
          }

          if (this.compareResultsService.exists() && (this.$rootScope as any).previousRoute.startsWith("/compare")) {
            if (sessionStorage.getItem("actualcomparisonList")) {
              var selectedProducts = sessionStorage.getItem("actualcomparisonList");
              this.comparisonList = JSON.parse(selectedProducts);
              sessionStorage.removeItem("actualcomparisonList");
            } else {
              this.comparisonList = JSON.parse(sessionStorage.getItem("ComparisonList"));
            }
            if (this.inActiveDealLender > 0) {
              this.comparisonList = this.comparisonList.concat(inActiveDealLenderList);
            }

            //Removing lsd data saved for compare view.
            this.compareResultsService.clear();
            sessionStorage.removeItem("ComparisonList");
          }
        });
    }
  }

  // updateGuidanceState() {
  //   this.tourEnabled = this.sharedSearchResultsService.updateGuidanceState(
  //     this.guidanceCheckbox,
  //   );
  // }

  // getGuidanceSwitchState() {
  //   return this.sharedSearchResultsService.getGuidanceSwitchState();
  // }

  // recordGuidanceCookie() {
  //   this.sharedSearchResultsService.recordGuidanceCookie(this.guidanceCheckbox);
  //   this.$rootScope.$broadcast("guidanceStateChanged");
  // }

  // tourNext(): void {
  //   this.tourState.tourStep++;
  //   this.$cookies.put("tourStep", this.tourState.tourStep);
  // }

  // tourBack(): void {
  //   this.tourState.tourStep--;
  //   this.$cookies.put("tourStep", this.tourState.tourStep);
  // }

  // tourSkip(): void {
  //   this.tourEnabled = false;
  //   this.$cookies.put("tourEnabled", "false");
  //   this.$cookies.remove("tourStep");
  // }

  // startTour(): void {
  //   this.tourState.tourStep = 1;
  //   this.tourState.tourTotalSteps = 0;
  //   this.$cookies.put("tourStep", this.tourState.tourStep);
  //   this.tourEnabled = true;
  //   this.$cookies.put("tourEnabled", "true");
  // }

  /**
   * Saves the new search name on the edit.
   * @param none
   */
  doRenameSearch() {
    if (this.loanCriteria.name != null && this.loanCriteria.name.length <= 0) {
      this.loanCriteria.name = this.tempLoanCriteria.name;
    }

    if (!this.isLoggedInUser) {
      this.openRegisterModal();
      return;
    }

    var request: SaveCommercialSearchRequest = {
      deal: this.loanCriteria,
      shareDealDto: this.shareDealDto,
      orgCode: this.orgCode,
      enterpriseClientDto: null,
      clientId: this.clientId,
    };

    if (this.searchid) {
      this.commercialDealClient.saveCommercialSearchReturnsId(request).then((response) => {
        this.toggleEditSearchName = false;
      });
    } else if (this.dealUniqueRef) {
      if (this.isLoggedInUser) {
        this.commercialDealClient.saveCommercialSearchReturnsUniqueRef(request).then((response) => {
          this.toggleEditSearchName = false;
        });
      } else {
        this.dealClient.renameDeal(this.dealUniqueRef, this.loanCriteria.name).then((response) => {
          this.toggleEditSearchName = false;
        });
      }
    } else {
      this.toggleEditSearchName = false;
    }
  }

  toggleLenderComparisonSelection(item: CommercialLenderResultSummaryDTO, index: number) {
    const comparisonMatches: CommercialLenderResultSummaryDTO[] = this.comparisonList.filter((result, index) => {
      return this.isMatchingLenderResult(result, item);
    });

    if (!comparisonMatches || comparisonMatches.length === 0) {
      this.comparisonList.push(item);
      this.eventLogClient.logEvent(
        `SHORTLISTING-RESULT`,
        EventLogEnum.Shortlisting,
        this.loanCriteria.productType,
        this.loanCriteria.id,
        "",
        item.productSourceType == ProductSourceTypeEnum.Internal ? item.productID.toString() : item.externalProductId,
        0,
      );
    } else {
      if (
        this.isShortlistingMore &&
        item.isDealLender &&
        this.loanCriteria.status != CaseStatusEnum.Search &&
        this.loanCriteria.status != CaseStatusEnum.NewCase
      )
        return;
      comparisonMatches.forEach((value, index) => {
        this.comparisonList.splice(this.comparisonList.indexOf(value), 1);
      });
      this.eventLogClient.logEvent(
        `DESELECTING-SHORTLISTED-RESULT`,
        EventLogEnum.Shortlisting,
        this.loanCriteria.productType,
        this.loanCriteria.id,
        "",
        item.productSourceType == ProductSourceTypeEnum.Internal ? item.productID.toString() : item.externalProductId,
        0,
      );
    }

    //This is user for shortlisting pdf
    this.prepareDataForShortlistPdf();
  }

  comparisonContains(item: CommercialLenderResultSummaryDTO): boolean {
    return !!this.comparisonList.find((result, index) => {
      //return result.productID === item.productID;
      return this.isMatchingLenderResult(result, item);
    });
  }

  checkLender(item: CommercialLenderResultSummaryDTO): boolean {
    if (this.userLenderId == item.lenderID) return true;
    return false;
  }

  selectionOrderNumber(item: CommercialLenderResultSummaryDTO) {
    const activeProductList = this.comparisonList.filter(
      (cl) =>
        cl.dealLenderStatus != CaseLenderStateEnum.Rejected && cl.dealLenderStatus != CaseLenderStateEnum.Withdrawn,
    );

    const hiddenProduct = this.HiddenDealLenderList.filter(
      (hl) => hl.status != CaseLenderStateEnum.Rejected && hl.status != CaseLenderStateEnum.Withdrawn,
    );
    const hiddenProductLength = this.isShortlistingMore ? hiddenProduct.length : 0;
    const order = activeProductList.findIndex((p) => this.isMatchingLenderResult(p, item)) + hiddenProductLength + 1;
    if (order === 0) {
      return " ";
    }

    return order;
  }

  /**
   * Processes the clicking of the "View Eligibility" anchor/button and index to show on the row number
   * @param item BridgingLenderResultSummaryDTO
   */
  viewEligibility(item: CommercialLenderResultSummaryDTO) {
    event.preventDefault(); // prevents default behaviour of href
    this.showProductNote = true;
    this.offer = item;
    this.loanLabel = item.loanLabel;
    this.productNote = item.additionalProductInfo;
  }

  /**
   *Marks a selected search as a deleted
   * @param
   */
  deleteSearch() {
    if (this.$routeParams.dealId) {
      this.dealClient
        .markAsDeleted(this.$routeParams.dealId)
        .then((response) => {
          this.displayMsg = "Search is successfully deleted";
          this.showMsg = true;
          this.ShowdeleteSearch = true;
        })
        .catch((error) => {
          this.displayMsg = "Sorry, something went wrong. Please try again.";
          this.showMsg = true;
        });
    }
  }

  closeDeleteModal() {
    this.showMsg = false;
    this.displayMsg = null;
    this.ShowdeleteSearch = false;
    this.warningOff = true;
    this.$auth.clearSelectedNavMenuAndFilterStorageData();
    this.$location.path("/userdashboard");
  }

  viewSingleLoan(item: CommercialLenderResultSummaryDTO) {
    event.preventDefault(); // prevents default behaviour of href
    this.warningOff = true;
    //Storing the actual comparisonList to local storage so that to recover it later when we comeback to result screen from compare screen.
    sessionStorage.setItem("actualcomparisonList", JSON.stringify(this.comparisonList));
    this.comparisonList = [];

    this.comparisonList.push(item);
    this.goCompare();
    (this.$rootScope as any).loanCriteria = this.loanCriteria;
  }

  goCompare() {
    this.warningOff = true;

    this.sharedSearchResultsService.clearStorageDataForCompareView();

    let comparisonList = this.comparisonList.filter(
      (cl) =>
        cl.dealLenderStatus != CaseLenderStateEnum.Rejected && cl.dealLenderStatus != CaseLenderStateEnum.Withdrawn,
    );

    sessionStorage.setItem("ComparisonList", JSON.stringify(comparisonList));

    this.compareResultsService.saveDealToSessionStorage(this.loanCriteria);

    if (this.dealClientUniqueRef) {
      if (!this.isLoggedInUser) {
        this.dealUniqueRef = this.loanCriteria.uniqueRef;
        //This property is used in compare view controller to find previous route
        sessionStorage.setItem("DealClientUniqueRef", this.dealClientUniqueRef);
      } else {
        this.searchid = this.loanCriteria.id;
      }
    }

    if (this.searchid) {
      this.$location.path("compare/" + this.searchid + "/" + 0 + "/" + true);
    } else {
      this.$location.path("compare/" + this.dealUniqueRef + "/" + 0 + "/" + true);
    }
  }

  showBookMeetingButton() {
    return !this.isLoggedInUser && this.isClient && this.brokerDetail == "" && this.brokerageOrg != null;
  }

  bookMeeting() {
    this.staticDataClient.getHubspotDeveloperBookMeetingWithSearch().then((hubSpotUrl: string) => {
      window.open(hubSpotUrl);
    });
  }

  sendMessageToBroker(message) {
    this.loadingData = true;
    this.borrowerMessage = null;
    this.organisationClient
      .sendBorrowerMessageToSearchBroker(
        this.loanCriteria.id,
        message,
        this.loanCriteria.dealClients[0].client.firstName,
        this.loanCriteria.dealClients[0].client.lastName,
        this.loanCriteria.dealClients[0].client.email,
        this.loanCriteria.productType,
        "Results",
        "",
      )
      .then((results) => {
        if (results) {
          this.displayMsg = `Message has been sent successfully.`;
          this.showMessageToborrower = true;
        } else {
          this.displayMsg = `There is problem sending a message, Please try later.`;
          this.showMessageToborrower = true;
        }
      })
      .finally(() => {
        this.loadingData = false;
      });
  }

  closeContactBrokerModal() {
    this.showContactBrokerModal = false;
    this.showMessageToborrower = false;
    this.displayMsg = null;
  }

  getTotalShortlistedLenders() {
    var activeDealLenders = this.comparisonList.filter(
      (al) =>
        al.dealLenderStatus != CaseLenderStateEnum.Rejected && al.dealLenderStatus != CaseLenderStateEnum.Withdrawn,
    );

    var hiddenProduct = this.HiddenDealLenderList.filter(
      (hl) => hl.status != CaseLenderStateEnum.Rejected && hl.status != CaseLenderStateEnum.Withdrawn,
    );
    var hiddenProductLength = this.isShortlistingMore ? hiddenProduct.length : 0;

    return activeDealLenders.length + hiddenProductLength;
  }

  go(path): void {
    this.$location.path(path);
  }

  changeSearch() {
    (this.$rootScope as any).loanCriteria = this.loanCriteria;
    this.warningOff = true;
    sessionStorage.setItem("skip", "true");
    if (!this.isLoggedInUser && (this.dealUniqueRef || this.dealClientUniqueRef)) {
      if (this.dealClientUniqueRef) sessionStorage.setItem("previousRoute", "referredsearchdeal");
      var url = `/e/commercialcriteria/${this.loanCriteria.uniqueRef}`;
      if (this.loanCriteria.organisationLinkId > 0) {
        url = `${url}/${this.loanCriteria.organisationLinkId}`;
      }
      this.go(url);
    } else if (this.searchid) {
      this.go("/commercialcriteria/" + this.searchid);
    } else {
      this.go("/commercialcriteria");
    }
  }

  newloan() {
    (this.$rootScope as any).loanCriteria = null;
    this.$location.path("/commercialcriteria/0");
  }

  updateSearchViaSlider(isAdminDebugValueChanged: boolean = false): void {
    if (this.searchPanelForm.$valid && !this.showPostcodeErrorMessage) {
      if (this.loanCriteria.ownOrPurchase == OwnOrPurchaseEnum.Purchasing) {
        if (this.loanCriteria.purchasePrice <= 0) return;
      }

      if (this.loanCriteria.ownOrPurchase == OwnOrPurchaseEnum.Own) {
        if (this.loanCriteria.currentvalue <= 0) return;
      }
      this.loadingData = true;
      this.hasSearchChanged = true;

      this.clearSelected();

      this.updateCriteriaAndGetResults(isAdminDebugValueChanged && this.isAdmin ? false : true);
    }
  }

  clearSelected() {
    if (this.isShortlistingMore) {
      this.comparisonList = this.comparisonList.filter((item) =>
        this.summarySearchResults.some((result) => this.isMatchingLenderResult(result, item)),
      );

      const dealLenders = this.initialSummarySearchResults.filter((result) => result.isDealLender);

      dealLenders.forEach((dealLender) => {
        if (!this.comparisonList.some((item) => this.isMatchingLenderResult(dealLender, item))) {
          this.comparisonList.push(dealLender);
        }
      });
    } else {
      this.comparisonList = this.comparisonList.filter((item) =>
        this.summarySearchResults.some((result) => this.isMatchingLenderResult(result, item)),
      );
    }
  }

  updateCriteriaAndGetResults(criteriaChanged: boolean, updateLoanLabels: boolean = false) {
    this.commercialDealClient
      .updateSearchAndGetResults({
        commercialDeal: this.loanCriteria,
        criteriaChanged: criteriaChanged,
        limit: 0,
        debug1: this.debug1,
        debug2: false,
        isPostcodeChange: this.isPostcodeChange,
        isShortlistingMore: this.isShortlistingMore,
      })
      .then((results) => {
        if (this.isPostcodeChange) {
          if (results.criteriaLocation != null) {
            this.loanCriteria.locations = results.criteriaLocation;
            this.summarySearchResults = results.results;
          } else {
            this.postcodeErrorMsg = results.postCodeErrorMessage;
            this.showPostcodeErrorMessage = true;
          }
        } else {
          this.summarySearchResults = results.results;
          this.sortSummaryResults();
        }
      })
      .catch((error) => {})
      .finally(() => {
        this.tempLoanCriteria = { ...this.loanCriteria };
        this.clearSelected();
        if (updateLoanLabels) {
          this.updateLoanLabels();
        }

        this.isPostcodeChange = false;
        this.loadingData = false;
      });
  }

  getSearchResultCount() {
    return this.sharedSearchResultsService.getSearchResultCount(this.summarySearchResults);
  }

  onPersonalGuaranteeLevelOptionsChange(e: BridgingPersonalGuaranteeLevelEnum) {
    switch (e) {
      case BridgingPersonalGuaranteeLevelEnum.None:
        this.loanCriteria.f_PersonalGuaranteeMin = 0.0;
        this.loanCriteria.f_PersonalGuaranteeMax = 0.0;
        break;
      case BridgingPersonalGuaranteeLevelEnum.OneToTwentyFivePercent:
        this.loanCriteria.f_PersonalGuaranteeMin = 0.0;
        this.loanCriteria.f_PersonalGuaranteeMax = 0.25;
        break;
      case BridgingPersonalGuaranteeLevelEnum.TwentySixToFiftyPercent:
        this.loanCriteria.f_PersonalGuaranteeMin = 0.25;
        this.loanCriteria.f_PersonalGuaranteeMax = 0.5;
        break;
      case BridgingPersonalGuaranteeLevelEnum.FiftyOneToOneHundredPercent:
        this.loanCriteria.f_PersonalGuaranteeMin = 0.5;
        this.loanCriteria.f_PersonalGuaranteeMax = 1.0;
        break;
      default:
        this.loanCriteria.f_PersonalGuaranteeMin = null;
        this.loanCriteria.f_PersonalGuaranteeMax = null;
        break;
    }
  }

  getPersonalGuaranteeLevelOptions() {
    return this.sharedSearchResultsService.getPersonalGuaranteeLevelOptions(
      this.tempLoanCriteria.f_PersonalGuaranteeMax,
    );
  }

  applyFilters() {
    this.loadingData = true;
    this.showFilters = false;
    this.updateCriteriaAndGetResults(false);
  }

  doClearClientFilters() {
    this.loanCriteria.f_IsFirstTimeDeveloper = null;
    this.loanCriteria.f_IsPersonalName = null;
    this.loanCriteria.f_IsOffshoreCompany = null;
    this.loanCriteria.f_IsMainShareholderOverseas = null;
    this.loanCriteria.f_MinOwnershipPeriod = null;
    this.personalGuaranteeLevel = null;
    this.loanCriteria.f_PersonalGuaranteeMin = null;
    this.loanCriteria.f_PersonalGuaranteeMax = null;
    this.loanCriteria.f_HasAdverseCredit = null;
    this.loanCriteria.f_MaxAgeAtEndOfMortgageTerm = null;
    this.loanCriteria.f_MaxAgeAtStartOfMortgageTerm = null;
  }

  showClearForClientFilters() {
    if (
      this.loanCriteria.f_IsFirstTimeDeveloper != null ||
      this.loanCriteria.f_IsPersonalName != null ||
      this.loanCriteria.f_MinOwnershipPeriod != null ||
      this.loanCriteria.f_IsOffshoreCompany != null ||
      this.loanCriteria.f_IsMainShareholderOverseas != null ||
      this.loanCriteria.f_PersonalGuaranteeMin != null ||
      this.loanCriteria.f_PersonalGuaranteeMax != null ||
      this.loanCriteria.f_HasAdverseCredit != null ||
      this.loanCriteria.f_MaxAgeAtEndOfMortgageTerm != null ||
      this.loanCriteria.f_MaxAgeAtStartOfMortgageTerm != null
    ) {
      return true;
    } else {
      return false;
    }
  }

  toggleCheckbox(variableName) {
    if (this.loanCriteria[variableName] === null || this.loanCriteria[variableName] === false) {
      this.loanCriteria[variableName] = true;
    } else {
      this.loanCriteria[variableName] = null;
    }
  }

  doClearFinanceFilters(): void {}
  doClearPropertyFilters() {
    this.loanCriteria.f_IsGradeOneListed = null;
    this.loanCriteria.f_IsGradeTwoListed = null;
    this.loanCriteria.f_IsTimberFrameConstruction = null;
    this.loanCriteria.f_IsConcreteConstruction = null;
    this.maxIndividualUnitPrice = null;
    this.loanCriteria.f_AcceptableEPCRating = null;
    this.loanCriteria.f_EWS1AcceptableType = null;
    this.loanCriteria.f_MaxIndividualUnitPrice = null;
    this.loanCriteria.f_MaxCommercialFloorspace = null;
  }

  showClearForPropertyFilters() {
    if (
      this.loanCriteria.f_IsGradeOneListed != null ||
      this.loanCriteria.f_IsGradeTwoListed != null ||
      this.loanCriteria.f_IsTimberFrameConstruction != null ||
      this.loanCriteria.f_IsConcreteConstruction != null ||
      this.maxIndividualUnitPrice != null ||
      this.loanCriteria.f_AcceptableEPCRating != null ||
      this.loanCriteria.f_EWS1AcceptableType != null ||
      this.loanCriteria.f_MaxIndividualUnitPrice != null ||
      this.loanCriteria.f_MaxCommercialFloorspace != null
    ) {
      return true;
    } else {
      return false;
    }
  }

  debugSearch() {
    const stringJSON = JSON.stringify(this.loanCriteria);
    navigator.clipboard
      .writeText(stringJSON)
      .then()
      .catch((e) => console.log(e));
  }

  getDisplayTextForProperty(property) {
    return this.sharedSearchResultsService.getDisplayTextForProperty(property);
  }

  getPropertyValue(property) {
    let propertyValue = this.tempLoanCriteria[property];
    switch (property) {
      case "f_PersonalGuaranteeMax":
        return this.selectListService
          .GetBridgingPersonalGuaranteeLevels()
          .find((item) => item.key === this.getPersonalGuaranteeLevelOptions())?.displayName;
      case "f_MaxIndividualUnitPrice":
        return this.selectListService
          .GetMaxHouseSalePrices()
          .find((item) => item.key === this.getMaxIndividualUnitPrice())?.displayName;
      case "f_AcceptableEPCRating":
        return this.selectListService
          .GetAcceptableEPCRating()
          .find((item) => item.key === this.getAcceptableEPCRating())?.displayName;
      case "f_EWS1AcceptableType":
        return this.selectListService.GetEWS1GradeType().find((item) => item.key === this.getEWS1GradeType())
          ?.displayName;
      case "f_MaxCommercialFloorspace":
        return this.selectListService
          .GetMaxCommercialFloorspaceOptions()
          .find((item) => item.key === this.tempLoanCriteria.f_MaxCommercialFloorspace)?.displayName;
      default:
        return propertyValue;
    }
  }

  filterPropertyToText(property: string) {
    let value = this.tempLoanCriteria[property];
    if (typeof value == "boolean" && value == true) {
      return;
    } else if (value != null && typeof value != "boolean") {
      return `: ${this.getPropertyValue(property)}`;
    } else if (value == null) {
      return;
    }
    return false;
  }

  countFiltersSelected() {
    let count = 0;
    count = this.sharedSearchResultsService.countFiltersSelected(this.tempLoanCriteria, this.filterProperties);
    return count;
  }

  checkFilterSelected(property: string) {
    return this.sharedSearchResultsService.checkFilterSelected(property, this.tempLoanCriteria);
  }

  onMaxIndividualUnitPriceChange(e: MaxIndividualUnitPriceEnum) {
    switch (e) {
      case MaxIndividualUnitPriceEnum.UpTo1Million:
        this.loanCriteria.f_MaxIndividualUnitPrice = 1000000;
        break;
      case MaxIndividualUnitPriceEnum.UpTo2Million:
        this.loanCriteria.f_MaxIndividualUnitPrice = 2000000;
        break;
      case MaxIndividualUnitPriceEnum.UpTo5Million:
        this.loanCriteria.f_MaxIndividualUnitPrice = 5000000;
        break;
      case MaxIndividualUnitPriceEnum.NoMax:
        this.loanCriteria.f_MaxIndividualUnitPrice = -999;
        break;
      default:
        this.loanCriteria.f_MaxIndividualUnitPrice = null;
        break;
    }
  }

  getMaxIndividualUnitPrice() {
    var value = null;
    switch (this.tempLoanCriteria.f_MaxIndividualUnitPrice) {
      case 1000000:
        value = MaxIndividualUnitPriceEnum.UpTo1Million;
        break;
      case 2000000:
        value = MaxIndividualUnitPriceEnum.UpTo2Million;
        break;
      case 5000000:
        value = MaxIndividualUnitPriceEnum.UpTo5Million;
        break;
      case -999:
        value = MaxIndividualUnitPriceEnum.NoMax;
        break;
      default:
        value = null;
        break;
    }
    return value;
  }

  getAcceptableEPCRating() {
    var value = null;
    switch (this.tempLoanCriteria.f_AcceptableEPCRating) {
      case EPCRatingTypeEnum.A:
      case EPCRatingTypeEnum.B:
      case EPCRatingTypeEnum.C:
      case EPCRatingTypeEnum.AtoC:
        value = EPCRatingTypeEnum.AtoC;
        break;
      case EPCRatingTypeEnum.D:
      case EPCRatingTypeEnum.E:
      case EPCRatingTypeEnum.DtoE:
        value = EPCRatingTypeEnum.DtoE;
        break;
      case EPCRatingTypeEnum.AboveE:
        value = EPCRatingTypeEnum.AboveE;
        break;
      default:
        value = null;
        break;
    }
    return value;
  }

  getEWS1GradeType() {
    var value = null;
    switch (this.tempLoanCriteria.f_EWS1AcceptableType) {
      case EWS1GradeTypeEnum.A:
        value = EWS1GradeTypeEnum.A;
        break;
      case EWS1GradeTypeEnum.B:
        value = EWS1GradeTypeEnum.B;
        break;
      default:
        value = null;
        break;
    }
    return value;
  }

  gotoSignInPage() {
    this.$location.path("/login");
  }

  goToLink(url) {
    var baseUrl = window.location.href.split("#!")[0] + "#!";
    var newUrl = baseUrl + url;
    window.open(newUrl, "_blank");
  }

  /**
   * Opens a 'share a search with client' modal if search do not have client attached to.
   * @param none
   */
  saveResultsForShareSearchToClient() {
    if (!this.isSaveAsClicked) {
      this.register(false, this.productResultList);
    } else {
      this.saveSaveAsSearch();
    }
    this.newSearch = false;
  }

  onClickSaveAs() {
    this.isSaveAsClicked = true;
    if (this.isAdmin || this.isBroker) {
      if (!this.shareDealDto) {
        this.shareDealDto = {
          isApplicant: true,
          isPrimary: true,
        } as ShareDealDTO;
      }
      this.shareDealDto.dealName = "";
      this.showShareSearchModal();
    } else {
      this.showSaveResults = 3;
    }
  }

  /**
   * Saves the search or saves the search and create a case.
   * @param createCase (boolean set to true when promoting search to case)
   */

  //TODO: this functon does not need a productResultList parameter but as views have been shared with devfinance we are passing it
  register(createCase: boolean = false, productResultList: number) {
    this.loadingData = true;
    if (this.isShortlistingMore) {
      if (this.validateAllLendersUnique(this.comparisonList) == true) {
        this.dealLenderClient
          .shortlistMoreLenders(this.loanCriteria.id, this.hasSearchChanged, this.getDealLenders(this.comparisonList))
          .then((response) => {})
          .then(() => {
            this.getSelectedProducts();
          })
          .finally(() => {
            this.loadingData = false;
          });
      } else {
        this.loadingData = false;
      }
    } else {
      if (this.shareDealDto && this.shareDealDto.dealName && this.shareDealDto.dealName.length > 0) {
        this.loanCriteria.name = this.shareDealDto.dealName;
      }

      const request: SaveCommercialSearchRequest = {
        clientId: null,
        deal: this.loanCriteria,
        shareDealDto: null,
        orgCode: "",
        enterpriseClientDto: null,
      };

      this.commercialDealClient
        .saveCommercialSearchReturnsId(request)
        .then((response) => {
          this.loanCriteria.id = response as number;
          this.loadingData = false;

          // Creating the case is done on the casedashboard for deals
          if (createCase) {
            this.$location.path("/commercialcasedashboard/" + this.loanCriteria.id + "/" + true);
          }

          var shortlistDealLenders = this.getDealLenders(this.comparisonList);

          const shortlistRequest: ShortlistRequest = {
            dealLenders: shortlistDealLenders,
            commercialShortlistedResults: this.comparisonList,
            bridgingShortlistedResults: null,
            devFinanceShortlistedResults: null,
          } as ShortlistRequest;

          this.dealLenderClient
            .dealLenderAddUpdateListReturnOnlyId(shortlistRequest)
            .then((response) => {
              if (this.dealLenders != null) {
                const deallenders = this.dealLenders.filter((lender) => response.indexOf(lender.id) === -1);

                deallenders.forEach((lender) => this.dealLenderClient.markAsDeleted(lender.id));
              }
            })
            .finally(() => {
              this.getSelectedProducts();
              this.isClicked = false;
              this.newSearch = false;
              this.isProceedClicked = false;
              this.showSaveResults = null;
              this.loadingData = false;
            });
        })
        .catch((response) => {
          //TODO BRIDGING - capture if an error has occurred and process it
          //this.isError = true;
          this.isProceedClicked = false;
        })
        .finally(() => {});
    }
  }

  /**
   * updates a seach with introducee details and saves it and sends emil to client if 'notifyBorrower' is set to true.
   * @param notifyBorrower
   */

  sendResultsToClient(notifyBorrower) {
    if (this.shareDealDto != null && this.shareDealDto.clientDto != null) {
      this.shareDealDto.clientDto.postalAddress = this.shareDealDto.clientDto.postalAddress ?? {
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        addressLine4: "",
        postCode: "",
      };
    }
    if (this.isSaveAsClicked) {
      this.saveSaveAsSearch(true);
    } else {
      this.loadingData = true;
      this.dealClient
        .shareDeal(this.shareDealDto)
        .then(() => {
          this.displayMsg = this.shareDealDto.emailLinkToClient
            ? "Search results have been sent to " +
              this.shareDealDto.clientDto.firstName +
              " " +
              this.shareDealDto.clientDto.lastName
            : "Search assigned to " +
              this.shareDealDto.clientDto.firstName +
              " " +
              this.shareDealDto.clientDto.lastName;
          //this.loanCriteria.dealClients[0] = this.shareDealDto.ClientDto;
          this.loanCriteria.name = this.shareDealDto.dealName;
          this.newSearch = false;
          this.showMsg = true;
          this.loadingData = false;
          this.isAssigned = true;
          this.reloadSearch = true;
        })
        .finally(() => {
          delete this.shareDealDto;
          this.loadingData = false;
        });
    }
  }

  getDealLenders(selectedLenders: CommercialLenderResultSummaryDTO[]) {
    var lendersList: DealLender[] = [];

    if (this.dealClientUniqueRef || this.dealUniqueRef) {
      this.searchid = this.loanCriteria.id;
    }

    selectedLenders.forEach((item) => {
      var dealLender: DealLender;

      if (this.dealLenders) {
        dealLender = this.dealLenders.find((dl) => this.isMatchingDealLender(item, dl));
      }

      if (!dealLender) {
        dealLender = {
          dealId: this.searchid,
          productId: item.productID,
          lenderId: item.lenderID,
          status: CaseLenderStateEnum.Shortlisted,
          originalNetLoan: item.netLoan,
          deal: null,
          product: null,
          lender: null,
          productSourceType: item.productSourceType,
          externalProductId: item.externalProductId,
        } as DealLender;
      }

      lendersList.push(dealLender);
    });

    var unselecteLenderList: DealLender[] = [];

    if (this.dealLenders) {
      unselecteLenderList = this.dealLenders.filter(
        (dl) =>
          !lendersList.some((ll) =>
            this.isMatchingByProductIdOrExternalId(
              {
                productID: dl.productId,
                externalProductId: dl.externalProductId,
                productSourceType: dl.productSourceType,
              },
              {
                productID: ll.productId,
                externalProductId: ll.externalProductId,
                productSourceType: ll.productSourceType,
              },
            ),
          ) &&
          (dl.status == CaseLenderStateEnum.Rejected || dl.status == CaseLenderStateEnum.Withdrawn),
      );
    }

    if (unselecteLenderList.length > 0) {
      unselecteLenderList.forEach((l) => {
        l.isDeleted = true;
        lendersList.push(l);
      });
    }

    return lendersList;
  }

  openSendResultsToBorrowerModal() {
    const client = this.loanCriteria.dealClients[0]["client"]; // TODO Deal FUTURE- always want to assume there's one for now until there's a redesign of sharing
    this.shareDealDto.dealId = this.loanCriteria.id;
    this.shareDealDto.dealName = this.loanCriteria.name;
    this.shareDealDto.isApplicant = true;
    this.shareDealDto.isPrimary = true;
    this.shareDealDto.clientDto = {
      firstName: client.firstName,
      lastName: client.lastName,
      email: client.email,
      phoneNumber: client.phoneNumber,
      clientUserId: client.clientUserId,
      postalAddress: client.postalAddress ?? {
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        addressLine4: "",
        postCode: "",
      },
    } as Client;
    this.existingborrower = null;
    this.newSearch = true;
    this.sharedSearch = true;
  }

  /**
   * Sends email to client attached to the search
   */
  sendShareSearchEmailToClient() {
    this.loadingData = true;
    this.shareDealDto.emailLinkToClient = true;
    this.dealClient
      .shareDeal(this.shareDealDto)
      .then(() => {
        this.displayMsg =
          "Search results have been sent to " +
          this.shareDealDto.clientDto.firstName +
          " " +
          this.shareDealDto.clientDto.lastName;
      })
      .catch((error) => {
        this.displayMsg = "Sorry, something went wrong. Please try again.";
      })
      .finally(() => {
        this.newSearch = false;
        this.showMsg = true;
        this.loadingData = false;
        this.sharedSearch = false;
      });
  }

  applyForLoan() {
    this.isProceedClicked = true;
    this.register(true, this.productResultList);
  }

  returnToCase() {
    const shortlistDealLenders = this.getDealLenders(this.comparisonList);
    const shortlistRequest: ShortlistRequest = {
      dealLenders: shortlistDealLenders,
      commercialShortlistedResults: this.comparisonList,
      bridgingShortlistedResults: null,
      devFinanceShortlistedResults: null,
    } as ShortlistRequest;

    if (this.isShortlistingMore) {
      // copy newly selected products/lenders to caselender
      this.dealLenderClient
        .shortlistMoreLenders(this.loanCriteria.id, this.hasSearchChanged, shortlistRequest)
        .then((response) => {
          if (response) {
            //sending 'Promote' as true if search has changed & 'NewShortlist' as true if isShortlistingMore
            this.$location.path(
              "/commercialcasedashboard/" +
                this.loanCriteria.id +
                "/" +
                null +
                "/" +
                true +
                "/" +
                this.hasSearchChanged,
            );
          }
        });
    } else {
      this.dealLenderClient.updateShortlistedLenders(shortlistRequest).then((response) => {
        this.$location.path("/commercialcasedashboard/" + this.loanCriteria.id);
      });
    }
  }

  toggleShowLenderNamesBrokerOverride() {
    // this.loanCriteria.showLenderInfoBrokerOverride = !this.loanCriteria.showLenderInfoBrokerOverride;
    if (this.searchPanelForm.$valid && !this.showPostcodeErrorMessage) {
      this.loadingData = true;
      this.updateCriteriaAndGetResults(false, true);
    }
  }

  onMortgageProductChange() {
    if (this.loanCriteria.mortgageInterestType == InterestRateTypeEnum.Variable) {
      this.loanCriteria.fixedRateTerm = null;
    } else if (this.loanCriteria.mortgageInterestType == InterestRateTypeEnum.Fixed) {
      this.loanCriteria.fixedRateTerm = FixedRateTermEnum.FiveYear;
    }
  }

  mortgageTermToLoanTerm(): void {
    this.loanCriteria.loanTermReq = this.mortgageTerm * 12;
  }

  /**Update the loan label in the comparison results based on the loan label returned in the results
   * Primary purpose is to update the loan label when the show lender names button is toggled
   * */
  updateLoanLabels() {
    for (let i = 0; i < this.comparisonList.length; i++) {
      const resultIndex = this.summarySearchResults.findIndex((item) => {
        return this.isMatchingLenderResult(this.comparisonList[i], item);
      });

      if (resultIndex > -1) {
        this.comparisonList[i].loanLabel = this.summarySearchResults[resultIndex].loanLabel;
      }
    }

    //This is used for shortlisting pdf
    this.prepareDataForShortlistPdf();
  }

  /*isMatchingByProductID(result: CommercialLenderResultSummaryDTO, item: CommercialLenderResultSummaryDTO) {
    return (
      item.productID != null &&
      item.productID === result.productID &&
      item.productSourceType === result.productSourceType
    );
  }

  isMatchingByExternalID(result: CommercialLenderResultSummaryDTO, item) {
    return (
      item.productID == null &&
      item.externalProductId === result.externalProductId &&
      item.productSourceType === result.productSourceType
    );
  }*/

  isMatchingLenderResult(result: CommercialLenderResultSummaryDTO, item: CommercialLenderResultSummaryDTO) {
    return this.isMatchingByProductIdOrExternalId(
      {
        productID: result.productID,
        externalProductId: result.externalProductId,
        productSourceType: result.productSourceType,
      },
      {
        productID: item.productID,
        externalProductId: item.externalProductId,
        productSourceType: item.productSourceType,
      },
    );
  }

  isMatchingDealLender(result: CommercialLenderResultSummaryDTO, item: DealLender) {
    return this.isMatchingByProductIdOrExternalId(
      {
        productID: result.productID,
        externalProductId: result.externalProductId,
        productSourceType: result.productSourceType,
      },
      {
        productID: item.productId,
        externalProductId: item.externalProductId,
        productSourceType: item.productSourceType,
      },
    );
  }

  isMatchingByProductIdOrExternalId(
    result: { productID: number | null; externalProductId: string; productSourceType: ProductSourceTypeEnum },
    selectedResult: {
      productID: number | null;
      externalProductId: string;
      productSourceType: ProductSourceTypeEnum;
    },
  ): boolean {
    const hasProductID = selectedResult.productID != null;

    return hasProductID
      ? selectedResult.productID === result.productID && selectedResult.productSourceType === result.productSourceType
      : selectedResult.externalProductId === result.externalProductId &&
          selectedResult.productSourceType === result.productSourceType;
  }

  onCurrentUseOfBuilding() {
    if (
      this.loanCriteria.currentPropertyType != null &&
      this.loanCriteria.currentPropertyType == PropertyTypeEnum.HMO
    ) {
      this.loanCriteria.unitCount = null;
      this.loanCriteria.timeLeftOnLease = TimeLeftOnLeaseEnum.OneToThreeYears;
    } else if (
      this.loanCriteria.currentPropertyType != null &&
      this.loanCriteria.currentPropertyType == PropertyTypeEnum.MultiUnitFreeholdBlock
    ) {
      this.loanCriteria.bedroomCount = null;
      this.loanCriteria.timeLeftOnLease = TimeLeftOnLeaseEnum.OneToThreeYears;
    } else if (
      this.loanCriteria.currentPropertyType != null &&
      this.loanCriteria.currentPropertyType != PropertyTypeEnum.MultiUnitFreeholdBlock &&
      this.loanCriteria.currentPropertyType != PropertyTypeEnum.HMO
    ) {
      this.loanCriteria.bedroomCount = null;
      this.loanCriteria.unitCount = null;
    }

    this.updateSearchViaSlider();
  }

  datasetupOnMaxLoanRequiredChange() {
    this.loanCriteria = DealHelper.dataSetupOnMaxLoanRequiredChange(this.loanCriteria);

    this.updateSearchViaSlider();
  }

  showContactBrokerAndExportButton() {
    if (
      this.brokerageOrg != null &&
      this.loanCriteria != null &&
      this.loanCriteria.dealClients != null &&
      this.loanCriteria.dealClients.length > 0 &&
      this.loanCriteria.dealClients[0]?.client != null &&
      this.loanCriteria.dealClients[0].client.email.length > 0
    ) {
      return true;
    } else {
      return false;
    }
  }

  //This is used in shortlisting pdf
  prepareDataForShortlistPdf() {
    this.loanCriteria.comparisonList = this.comparisonList.filter(
      (cl) =>
        cl.dealLenderStatus != CaseLenderStateEnum.Rejected && cl.dealLenderStatus != CaseLenderStateEnum.Withdrawn,
    );
  }

  isProceedButtonDisabled(): boolean {
    if (this.validateAllLendersUnique(this.comparisonList) == false) {
      return true;
    }

    const validLenders =
      this.comparisonList?.filter(
        (item) =>
          item.dealLenderStatus !== CaseLenderStateEnum.Rejected &&
          item.dealLenderStatus !== CaseLenderStateEnum.Withdrawn,
      ) || [];

    if (
      !validLenders ||
      validLenders.length < 1 ||
      validLenders.length > this.noOfShortlistAllowed ||
      this.isProceedClicked == true
    ) {
      return true;
    }

    return false;
  }

  validateAllLendersUnique(comparisonList: CommercialLenderResultSummaryDTO[]): boolean {
    if (this.isShortlistingMore) {
      const matchingItems = this.HiddenDealLenderList.filter((item1) =>
        this.comparisonList.some((item2) => item1.lenderId === item2.lenderID),
      );

      if (matchingItems.length > 0) return false;
    }

    const numberOfUniqueLenderIds: number = new Set(this.comparisonList.map((item) => item.lenderID)).size;

    return numberOfUniqueLenderIds == this.comparisonList.length;
  }

  getRegionByPostcode() {
    if (this.loanCriteria.postcodeSearchString && this.loanCriteria.postcodeSearchString.replace(" ", "").length >= 2) {
      if (DealHelper.isValidPostcodeString(this.loanCriteria.postcodeSearchString)) {
        this.showPostcodeErrorMessage = false;
        this.isPostcodeChange = true;
        this.updateSearchViaSlider();
      } else {
        this.postcodeErrorMsg = "At least one letter and one number must be entered e.g. SW1.";
        this.showPostcodeErrorMessage = true;
      }
    }
  }

  getOrganisationAndBrokerDetails() {
    if (!this.isLoggedInUser && !this.isAdmin && !this.isBroker) {
      this.loadingData = true;
      this.organisationClient
        .getOrganisationAndBrokerByDealId(this.loanCriteria.id)
        .then((response) => {
          if (response && response.organisation != null) {
            this.brokerageOrg = response.organisation as Organisation;

            if (response.organisation.isBrickflow) {
              this.moveContactBrokerBtnInMiddle = true;
            } else {
              if (response.broker != null) {
                this.brokerDetail = `${response.broker.fullName} (${response.broker.email})`;
              }

              if (this.brokerageOrg.isWhiteLabelled) {
                this.orgName = this.brokerageOrg.name.replace(/ /g, "_");
              }
            }
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    }
  }

  sortByField(field) {
    this.loanCriteria.sortBy = field;
    this.loadingData = true;
    this.commercialDealCrudClient
      .patch({
        id: this.loanCriteria.id,
        sortBy: this.loanCriteria.sortBy,
      })
      .then(() => {
        this.sortSummaryResults();
      })
      .finally(() => {
        this.loadingData = false;
      });
    this.showSortBy = !this.showSortBy;
  }

  sortSummaryResults() {
    const hasSortOrder = this.loanCriteria.sortOrder !== SortOrderEnum.None;
    const orderMultiplier = this.loanCriteria.sortOrder === SortOrderEnum.Descending ? -1 : 1;

    switch (this.loanCriteria && this.loanCriteria.sortBy) {
      case SortByEnum.NetLoanSize:
        this.summarySearchResults.sort(
          hasSortOrder
            ? (a, b) => (a.netLoan - b.netLoan) * orderMultiplier || a.trueMonthlyCost - b.trueMonthlyCost
            : (a, b) => b.netLoan - a.netLoan || a.trueMonthlyCost - b.trueMonthlyCost,
        );
        break;

      case SortByEnum.LenderCosts:
        this.summarySearchResults.sort(
          hasSortOrder
            ? (a, b) => (a.trueMonthlyCost - b.trueMonthlyCost) * orderMultiplier
            : (a, b) => a.trueMonthlyCost - b.trueMonthlyCost,
        );
        break;

      case SortByEnum.LenderName:
        this.summarySearchResults.sort(
          hasSortOrder
            ? (a, b) =>
                a.lenderName.localeCompare(b.lenderName) * orderMultiplier || a.trueMonthlyCost - b.trueMonthlyCost
            : (a, b) => a.lenderName.localeCompare(b.lenderName) || a.trueMonthlyCost - b.trueMonthlyCost,
        );
        break;

      case SortByEnum.InterestRate:
        this.summarySearchResults.sort(
          hasSortOrder
            ? (a, b) => (a.annualInterest - b.annualInterest) * orderMultiplier || a.trueMonthlyCost - b.trueMonthlyCost
            : (a, b) => a.annualInterest - b.annualInterest || a.trueMonthlyCost - b.trueMonthlyCost,
        );
        break;

      case SortByEnum.ArrangementFee:
        this.summarySearchResults.sort(
          hasSortOrder
            ? (a, b) => (a.arrangementFee - b.arrangementFee) * orderMultiplier || a.trueMonthlyCost - b.trueMonthlyCost
            : (a, b) => a.arrangementFee - b.arrangementFee || a.trueMonthlyCost - b.trueMonthlyCost,
        );
        break;

      case SortByEnum.DepositEquity:
        this.summarySearchResults.sort(
          hasSortOrder
            ? (a, b) =>
                (a.equityOrDeposit - b.equityOrDeposit) * orderMultiplier || a.trueMonthlyCost - b.trueMonthlyCost
            : (a, b) => a.equityOrDeposit - b.equityOrDeposit || a.trueMonthlyCost - b.trueMonthlyCost,
        );
        break;

      case SortByEnum.MonthlyPayment:
        this.summarySearchResults.sort(
          hasSortOrder
            ? (a, b) => (a.monthlyPayment - b.monthlyPayment) * orderMultiplier || a.trueMonthlyCost - b.trueMonthlyCost
            : (a, b) => a.monthlyPayment - b.monthlyPayment || a.trueMonthlyCost - b.trueMonthlyCost,
        );
        break;

      default:
        if (!this.summarySearchResults) return;

        this.summarySearchResults.sort(
          hasSortOrder
            ? (a, b) => (a.netLoan - b.netLoan) * orderMultiplier || a.trueMonthlyCost - b.trueMonthlyCost
            : (a, b) => {
                if (a.netLoan < b.netLoan) return 1;
                if (a.netLoan > b.netLoan) return -1;
                if (a.trueMonthlyCost > b.trueMonthlyCost) return 1;
                if (a.trueMonthlyCost < b.trueMonthlyCost) return -1;
                return 0;
              },
        );
        this.loanCriteria.sortBy = SortByEnum.NetLoanSize;
    }

    // Set default sort order if none is defined
    if (this.loanCriteria.sortOrder === SortOrderEnum.None) {
      switch (this.loanCriteria.sortBy) {
        case SortByEnum.NetLoanSize:
          this.loanCriteria.sortOrder = SortOrderEnum.Descending;
          break;
        case SortByEnum.LenderCosts:
        case SortByEnum.LenderName:
        case SortByEnum.InterestRate:
        case SortByEnum.ArrangementFee:
        case SortByEnum.DepositEquity:
        case SortByEnum.MonthlyPayment:
          this.loanCriteria.sortOrder = SortOrderEnum.Ascending;
          break;
        default:
          this.loanCriteria.sortOrder = SortOrderEnum.Descending;
      }
    }

    // Assign row numbers
    for (let i = 0; i < this.summarySearchResults.length; i++) {
      this.summarySearchResults[i].selectedRowNumber = i + 1;
    }
  }

  /** Redirects to the user dashboard */
  goToUserDashboard() {
    this.$auth.clearSelectedNavMenuAndFilterStorageData();
    this.$location.path("/userdashboard");
  }

  submitLenderReferral() {
    this.loadingData = true;
    this.lenderReferralData.dealId = this.loanCriteria.id;
    this.dealClientClient
      .submitLenderReferral(this.lenderReferralData)
      .then((response) => {
        if (response) {
          this.displayMsg = "Your referral has been submitted.";
          this.showMsg = true;
          this.isLenderReferredSearch = true;
        } else {
          this.displayMsg = "Error while making a referral, please try later.";
          this.showMsg = true;
        }
      })
      .finally(() => {
        this.loadingData = false;
        this.lenderReferralData = null;
        sessionStorage.removeItem("lenderReferralReference");
      });
  }

  reloadPage() {
    if (this.reloadSearch) {
      window.location.reload();
    }
  }

  openRegisterModal() {
    if (window.self == window.top && this.$cookies.get("access_token")) {
      this.reloadSearch = true;
      this.reloadPage();
    } else {
      this.showRegisterModal = true;
    }
  }

  onEditSearchNameClick() {
    this.toggleEditSearchName = !this.toggleEditSearchName;
  }

  onSortbyClick() {
    this.closeFilterOptions();
    this.closeExportDropdown();
    this.showSortBy = !this.showSortBy;
  }

  onFilterClick() {
    this.closeSortByDropdown();
    this.closeExportDropdown();
    this.showFilters = !this.showFilters;
  }

  onExportClick() {
    this.prepareDataForShortlistPdf();
    this.closeSortByDropdown();
    this.closeFilterOptions();
    this.showExportOptions = !this.showExportOptions;
  }

  getSelectedSortByOptionText() {
    if (this.loanCriteria) {
      switch (this.loanCriteria.sortBy) {
        case SortByEnum.TrueMonthlyCost:
          return "True Monthly Cost";
        case SortByEnum.NetLoanSize:
          return "Net Loan Size";
        case SortByEnum.LenderCosts:
          return "Total Loan Costs";
        case SortByEnum.LenderName:
          return "Lender Name (A-Z)";
        case SortByEnum.InterestRate:
          return "Interest Rate";
        case SortByEnum.ArrangementFee:
          return "Arrangement Fee";
        case SortByEnum.DepositEquity:
          return "Equity";
        case SortByEnum.ROCE:
          return "ROCE";
        case SortByEnum.MonthlyPayment:
          return "Monthly Payment";
        default:
          return "";
      }
    } else {
      return "";
    }
  }

  createAccount() {
    this.loadingData = true;
    this.enterpriseClient.orgUniqueRef = this.brokerageOrg.uniqueRef;
    this.enterpriseClient.name = this.enterpriseClient.email;
    this.enterpriseClient.oidcId = this.enterpriseClient.email;
    this.userClient
      .registerEnterpriseUserAndSaveShortlisteResults({
        enterpriseUser: this.enterpriseClient,
        shortlistedResults: this.getDealLenders(this.comparisonList),
        password: this.password,
        dealUniqueRef: this.toggleEditSearchName ? this.loanCriteria.uniqueRef : "",
        newDealName: this.toggleEditSearchName ? this.loanCriteria.name : "",
      })
      .then((response) => {
        // clean up session storage
        if (window.self == window.top) {
          sessionStorage.removeItem("clientId");
          sessionStorage.removeItem("userRole");
        } else {
          this.organisationService.sendDataToParent("clientId", "");
          this.organisationService.sendDataToParent("userRole", "");
        }
        this.login("ENTERPRISE-LEAD-REGISTERED-FROM-RESULTS-PAGE", EventLogEnum.EnterpriseUserRegistration);
      })
      .catch((response) => {
        this.error = "Error while registering an account, please try again later.";
      })
      .finally(() => {
        this.loadingData = false;
      });
  }

  login(
    eventIdentifier: string = "ENTERPRISE-CONTACT-LOGGEDIN-FROM-RESULTS-PAGE",
    eventType: EventLogEnum = EventLogEnum.EnterpriseUserLogin,
  ) {
    this.loadingData = true;
    if (!this.$cookies.get("access_token")) {
      this.$auth
        .newLogin(this.enterpriseClient.userName, this.password, "CC022EBE67BE0424EA2A6548B062D2D71")
        .then((response) => {
          this.error = "";
          let expiry: Date = response;
          this.eventLogClient.logEvent(
            eventIdentifier,
            eventType,
            this.loanCriteria.productType,
            this.loanCriteria.id,
            "",
            "",
            this.loanCriteria.dealClients[0]?.client.id,
          );

          this.$rootScope.$broadcast("login"); //tell everyone you have logged in
          if (eventType == EventLogEnum.EnterpriseUserRegistration)
            sessionStorage.setItem("showConfirmClientPhoneNo", "true");
          this.$location.path(`/commercialresults/${this.loanCriteria.id}`);
        })
        .catch((response) => {
          this.isLoginError = true;
        })
        .finally(() => {
          this.loadingData = false;
        });
    }
  }

  onClickLogin() {
    this.saveShortlistedLenders();
    this.login();
  }

  saveShortlistedLenders() {
    const shortlistDealLenders = this.getDealLenders(this.comparisonList);
    const shortlistRequest: ShortlistRequest = {
      dealLenders: shortlistDealLenders,
      commercialShortlistedResults: this.comparisonList,
      bridgingShortlistedResults: null,
      devFinanceShortlistedResults: null,
    } as ShortlistRequest;
    this.dealLenderClient.updateShortlistedLenders(shortlistRequest).then((response) => {});
  }

  returnShortlistedDealLenderStatusText(item: CommercialLenderResultSummaryDTO) {
    if (this.checkDeletedLender(item.lenderID, item.productID, item.externalProductId)) {
      return "Previously Deleted";
    }

    if (
      item.isDealLender &&
      this.loanCriteria.status != CaseStatusEnum.Search &&
      this.loanCriteria.status != CaseStatusEnum.NewCase &&
      this.loanCriteria.status != CaseStatusEnum.ReadyToSubmit
    ) {
      switch (item.dealLenderStatus) {
        case CaseLenderStateEnum.Shortlisted:
          return "Shortlisted";
        case CaseLenderStateEnum.Received:
          return "Awaiting DIP";
        case CaseLenderStateEnum.Offered:
          return "DIP Received";
        case CaseLenderStateEnum.Rejected:
          return "Lender Rejected";
        case CaseLenderStateEnum.Withdrawn:
          return "Lender Withdrawn";
        case CaseLenderStateEnum.Applied:
          return "DIP Accepted";
        case CaseLenderStateEnum.Cancelled:
          return "Cancelled";
        default:
          break;
      }
    }
  }

  onSaveClick() {
    if (this.isAssigned) {
      this.isSaveorSaveAsClicked = true;
      this.register(false, this.productResultList);
    } else {
      this.showShareSearchModal();
    }
  }

  getProductLastVerifiedDates(productIds: (number | null)[]) {
    productIds = productIds.filter((item) => item !== null);
    this.productClient.getLastVerifiedDates(productIds).then((response) => {
      productIds.forEach((id) => {
        if (response[id] != null) {
          this.productLastVerifiedDates[id] = this.formatDate(response[id]);
        }
      });
    });
  }

  formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB");
  };

  closeFilterOptions() {
    this.showFilters = false;
  }

  closeSortByDropdown() {
    this.showSortBy = false;
  }

  closeExportDropdown() {
    this.showExportOptions = false;
  }

  updateClientContactInfoAndNotifyBroker() {
    if (this.loanCriteria != null && this.loanCriteria.dealClients != null) {
      this.dealClientClient
        .updateClientContactInfoAndNotifyBroker(
          this.clientUpdatedContact,
          this.loanCriteria?.id,
          this.loanCriteria.dealClients[0].client.id,
        )
        .then((response) => {
          this.showClientPhoneNumberConfirmationModal = false;
          this.sliderShown = true;
        })
        .catch((response) => {
          this.error = "There was an error updating the contact. Please try again later.";
        })
        .finally(() => {
          sessionStorage.removeItem("showConfirmClientPhoneNo");
        });
    } else {
      sessionStorage.removeItem("showConfirmClientPhoneNo");
      this.showClientPhoneNumberConfirmationModal = false;
      this.sliderShown = true;
    }
  }

  getOrgName() {
    if (this.orgName) {
      return this.orgName.replace(/_/g, " ");
    }
    return "";
  }

  /**Sends an email to the email address for the user to reset their password */
  sendResetPasswordEmail() {
    this.loadingData = true;
    this.userClient
      .resetForgottenPassword(this.enterpriseClient.email)
      .then((response) => {
        this.isLoginError = false;
        this.isResetPasswordSubmitted = true;
        this.registrationLoginError = null;
      })
      .catch((error) => {
        this.registrationLoginError = "There was an error sending the password reset email. Please try again later.";
      })
      .finally(() => {
        this.loadingData = false;
      });
  }

  getRequiredRolesOptions() {
    return DealHelper.getRequiredRolesOptions();
  }

  validateAccessAndRedirect() {
    //Do not allow the connect user to access the deal
    if (this.loanCriteria && this.isLoggedInUser && this.loanCriteria.isReferredToConnect && this.isConnectUser) {
      this.$location.path(`/commercialcasedashboard/${this.loanCriteria.id}`);
    } else {
      if (
        this.loanCriteria &&
        this.isLoggedInUser &&
        this.loanCriteria.status != CaseStatusEnum.NewCase &&
        this.loanCriteria.status != CaseStatusEnum.Search &&
        !this.isShortlistingMore
      ) {
        this.dealLenderClient.fetchDealLendersByDealId(this.loanCriteria.id).then((results) => {
          if (
            results &&
            results.filter(
              (dl) =>
                !dl.isDeleted &&
                dl.status != CaseLenderStateEnum.Withdrawn &&
                dl.status != CaseLenderStateEnum.Rejected,
            ).length >= 5 &&
            results.filter((dl) => !dl.isDeleted && dl.isBidAccepted)
          ) {
            if (this.isAdmin || this.isBroker) {
              this.$location.path("/dealforum/" + this.loanCriteria.id);
            } else {
              this.$location.path(`/userdashboard`);
            }
          } else {
            this.$location.path(`/commercialshortlistmore/${this.loanCriteria.id}`);
          }
        });
      }
    }
  }

  flagIncorrectRateOrCriteria() {
    this.loadingData = true;
    let totalLoanCost = "";
    const formatCurrency = (value) => "£" + this.$filter("number")(value, 0);
    const formatPercent = (value, decimalPlace) => this.$filter("number")(value * 100, decimalPlace) + "%";

    const {
      lenderName,
      annualInterest,
      arrangementFee,
      arrangementFeePercOfValue,
      fixedRateTermText,
      netLoan,
      equityOrDeposit,
      trueMonthlyCost,
      loanTerm,
      monthlyPayment,
      loanToValue,
      loanRepaymentTypeText,
    } = this.flaggedOffer;

    const equityOrDepositText = this.loanCriteria.ownOrPurchase === OwnOrPurchaseEnum.Own ? "Equity" : "Deposit";
    if (this.loanCriteria.mortgageInterestType === InterestRateTypeEnum.Fixed) {
      totalLoanCost = `<li>Total Loan Costs: ${formatCurrency(trueMonthlyCost)}</li>`;
    }

    const resultsText = `
      <ul>
        <li>${lenderName}</li>
        <li>${formatPercent(annualInterest, 2)} interest rate · ${formatPercent(
          arrangementFeePercOfValue,
          2,
        )} arrangement fee · ${fixedRateTermText} . ${loanRepaymentTypeText}</li>
        <li>Net loan: ${formatCurrency(netLoan)}</li>
        <li>Monthly Payment: ${formatCurrency(monthlyPayment)}</li>
        <li>Arrangement Fee: ${formatCurrency(arrangementFee)}</li>
        ${totalLoanCost}
        <li>${equityOrDepositText}: ${formatCurrency(equityOrDeposit)}</li>
        <li>LTV: ${formatPercent(loanToValue, 0)}</li>
        <li>Mortgage Term: ${loanTerm / 12} Years</li>
      </ul>
    `;
    const request = {
      resultsText: resultsText,
      dealId: this.loanCriteria.id,
      additionalDetails: this.flaggingDetails,
      incorrectDataType: this.incorrectDataType,
    } as FlagIncorrectRateOrCriteriaRequest;

    this.dealClient
      .flagIncorrectRateOrCriteria(request)
      .then(() => {
        this.setFlaggedSuccessMessage(
          `Incorrect ${this.incorrectDataType == IncorrectDataTypeEnum.Rate ? "rate" : "criteria"} flagged for review.`,
        );
        this.$timeout(() => {
          this.setFlaggedSuccessMessage("");
        }, 3000);
      })
      .catch(() => {
        this.setFlaggedSuccessMessage("Error while submitting, please try later.");
        this.$timeout(() => {
          this.setFlaggedSuccessMessage("");
        }, 3000);
      })
      .finally(() => {
        this.loadingData = false;
        this.flaggingDetails = "";
        this.showFlaggingModal = false;
      });
  }

  onFlaggingOptionSelected(offer, index, incorrectDataType) {
    this.showFlaggingModal = true;
    this.flaggedOffer = offer;
    this.showFlaggingOptions[index] = false;
    this.incorrectDataType = incorrectDataType;
  }

  onSortOrderClick() {
    this.loadingData = true;

    this.loanCriteria.sortOrder =
      this.loanCriteria.sortOrder === SortOrderEnum.Ascending ? SortOrderEnum.Descending : SortOrderEnum.Ascending;

    this.commercialDealCrudClient
      .patch({
        id: this.loanCriteria.id,
        sortOrder: this.loanCriteria.sortOrder,
      })
      .then(() => {
        this.sortSummaryResults();
      })
      .finally(() => {
        this.loadingData = false;
      });
  }
}
